__turbopack_context__.v({
  "pageSection": "PageSection-module__ZqXKcq__pageSection",
});
